import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import MyAutocomplete from '../form/fields/MyAutocomplete'

// Renders as a filled autocomplete in every state — when a person is selected it looks exactly
// like the neighbouring filled fields (e.g. Livestream Type): floating label + value + chevron,
// and changing is just picking another option. Keeps the height identical whether or not a
// person is selected.
// `multiple` turns this into a chip-based multi-select: `selected` is then an array of options
// and `onChange` receives an array of ids. In single mode `selected` is one option (or null) and
// `onChange` receives one id (or null).
const PersonSelectCard = ({ fieldName, label, options, selected, onChange, disabled, multiple }) => (
  <div className='div-flex' style={{ opacity: disabled ? 0.45 : 1 }}>
    <Field
      name={fieldName}
      label={label}
      style={{ width: '100%' }}
      disabled={disabled}
      multiple={multiple}
      filterSelectedOptions={multiple}
      options={options}
      component={MyAutocomplete}
      getOptionLabel={(option) => option?.name ?? ''}
      getOptionSelected={(option, sel) => option.id === sel?.id}
      value={selected}
      onChange={
        multiple
          ? (e, opts) => onChange((opts ?? []).map((o) => o.id))
          : (e, option) => onChange(option?.id ?? null)
      }
    />
  </div>
)

PersonSelectCard.propTypes = {
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    }),
  ),
  selected: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
      }),
    ),
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
}

PersonSelectCard.defaultProps = {
  options: [],
  selected: null,
  disabled: false,
  multiple: false,
}

export default PersonSelectCard
